import api from "./axiosInstance"; 

export const getUserTypePermissions = async (userTypeId) => {
  const res = await api.get(
    `api/v1/account/user-types/${userTypeId}/`
  );
  return res.data.permissions;
};
